/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliveryCalculationInternationalFeeGradeFeeRespVo } from './DeliveryCalculationInternationalFeeGradeFeeRespVo';
import {
    DeliveryCalculationInternationalFeeGradeFeeRespVoFromJSON,
    DeliveryCalculationInternationalFeeGradeFeeRespVoFromJSONTyped,
    DeliveryCalculationInternationalFeeGradeFeeRespVoToJSON,
    DeliveryCalculationInternationalFeeGradeFeeRespVoToJSONTyped,
} from './DeliveryCalculationInternationalFeeGradeFeeRespVo';

/**
 * 
 * @export
 * @interface DeliveryCalculationInternationalFeeRespVo
 */
export interface DeliveryCalculationInternationalFeeRespVo {
    /**
     * 仓库ID
     * @type {number}
     * @memberof DeliveryCalculationInternationalFeeRespVo
     */
    warehouseId?: number;
    /**
     * 运输方式ID
     * @type {number}
     * @memberof DeliveryCalculationInternationalFeeRespVo
     */
    transportMethodId?: number;
    /**
     * 国际运费分组：1电商快递，2海运物流，3橙火服务，4韩国3PL
     * @type {number}
     * @memberof DeliveryCalculationInternationalFeeRespVo
     */
    orderTypeGroup?: number;
    /**
     * 计费标准
     * 计费标准：1-重量 2-CBM 3-区间值
     * @type {number}
     * @memberof DeliveryCalculationInternationalFeeRespVo
     */
    chargeStandard?: number;
    /**
     * 会员等级运费
     * 会员等级运费列表
     * @type {Array<DeliveryCalculationInternationalFeeGradeFeeRespVo>}
     * @memberof DeliveryCalculationInternationalFeeRespVo
     */
    grades?: Array<DeliveryCalculationInternationalFeeGradeFeeRespVo>;
}

/**
 * Check if a given object implements the DeliveryCalculationInternationalFeeRespVo interface.
 */
export function instanceOfDeliveryCalculationInternationalFeeRespVo(value: object): value is DeliveryCalculationInternationalFeeRespVo {
    return true;
}

export function DeliveryCalculationInternationalFeeRespVoFromJSON(json: any): DeliveryCalculationInternationalFeeRespVo {
    return DeliveryCalculationInternationalFeeRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationInternationalFeeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationInternationalFeeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'chargeStandard': json['chargeStandard'] == null ? undefined : json['chargeStandard'],
        'grades': json['grades'] == null ? undefined : ((json['grades'] as Array<any>).map(DeliveryCalculationInternationalFeeGradeFeeRespVoFromJSON)),
    };
}

export function DeliveryCalculationInternationalFeeRespVoToJSON(json: any): DeliveryCalculationInternationalFeeRespVo {
    return DeliveryCalculationInternationalFeeRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationInternationalFeeRespVoToJSONTyped(value?: DeliveryCalculationInternationalFeeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'chargeStandard': value['chargeStandard'],
        'grades': value['grades'] == null ? undefined : ((value['grades'] as Array<any>).map(DeliveryCalculationInternationalFeeGradeFeeRespVoToJSON)),
    };
}

